// extracted by mini-css-extract-plugin
export default {"page":"Encuesta_page__h53Mf"};